__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-spa/phx-rel-R25.4.3-16APR20251216PMIST/_next/";